import { Display } from "ds_legacy/materials/typography";
import { useTranslations } from "translations";

export default function InactiveProfilePage({
  careproviderName = "",
}: {
  careproviderName: string | undefined;
}) {
  const translations = useTranslations();
  return (
    <div className="flex h-screen w-screen flex-1 flex-col items-center justify-center">
      <Display style={{ marginBottom: 0 }}>
        {`${careproviderName} ${translations.careproviderApp.inactiveProfile.titleTop}`}
      </Display>
      <Display style={{ marginTop: 0 }}>
        {translations.careproviderApp.inactiveProfile.titleBottom}
      </Display>
    </div>
  );
}
